import { ExperimentPlateNodeProps } from 'business/models/CustomModels';
import React from 'react';
import TreeNode from './TreeNode';

export default function ExperimentPlateNode(props: ExperimentPlateNodeProps) {
  const data = { ...props };
  data.type = 'ExperimentPlate';
  data.name = `${props.plateNumber}, ${props.id}, ${props.barcode}`;

  return <TreeNode data={data} />;
}
